import React, { useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import frame1 from "../../assets/images/frame1.png";
import { AiFillEdit } from "react-icons/ai";
import { PiFilePdf } from "react-icons/pi";
import ProductDetailCard from "../../components/cards/productDetailCard"
import { useEffect } from "react";
import { useViewSingleProduct } from "../../hooks/products/product.show";


const ProductDetailPage = () => {
  const { productName, id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const product = location.state?.product;
  const { data: productData, isLoading } = useViewSingleProduct(id);
  const [productDetails, setProductDetails] = useState(null);


  const [active, setActive] = useState("Images");
  const [showFullDescription, setShowFullDescription] = useState(false);
  const tabs = ["Images", "Videos", "Catalogue"];


  useEffect(() => {
    if(productData && productData.data){
      setProductDetails(productData.data);
    }
  }, [productData]);

  console.log("ProductDetailPage - productDetails:", productDetails);

  const currentProductId = id || productName || "N/A";

  
  return (
    <>
      <div className="breadcrumb-productlist-row breadcrumb-align-standard">
        <div className="breadcrumb-productlist-col">
          <p className="breadcrumb-text">
            <span
              role="button"
              tabIndex={0}
              onClick={() => navigate("/dashboard")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              Dashboard
            </span>{" "}
            &gt;{" "}
            <span
              role="button"
              tabIndex={0}
              onClick={() => navigate("/products/ProductList")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") navigate("/products/ProductList");
              }}
              style={{ cursor: "pointer" }}
            >
              Product List
            </span>{" "}
            &gt; <span>{currentProductId}</span>
          </p>
          <h1 className="productlist-title">Product List</h1>
        </div>
        <button
          className="commonButton"
          onClick={() => navigate("/products/EditProducts/" + id)}
        >
          <AiFillEdit size={20} color="#ffffff" style={{ marginRight: 8 }} /> Edit
          Product
        </button>
      </div>
      <div className="body">
        {/* Tab Navigation */}
        <div className="product-detail-container">
          <div className="frame-one">
            <img 
              src={productDetails?.thumbnail_image ? `${process.env.REACT_APP_BASE_IMAGE}/${productDetails.thumbnail_image.replace(/\\/g, "/")}` : frame1} 
              alt="frame" 
              style={{ width: "100%", height: 300, objectFit: "cover", borderRadius: 8 }}
            />
            <div className="content">
              <h2>
                {productDetails?.title || "Product Details Not Available"}
              </h2>
            </div>
            {/* <p className={showFullDescription ? "description" : "description product-description-clamp"}>
              {productDetails?.description ||
                "No description available for this product."}
            </p>
            {productDetails?.description && productDetails.description.length > 120 && (
              <button
                className="view-more-btn"
                onClick={() => setShowFullDescription((prev) => !prev)}
              >
                {showFullDescription ? "View Less" : "View More"}
              </button>
            )} */}
      <ProductDetailCard 
        category={productDetails?.category}
        macroFamily={productDetails?.macroFamily}
        industry={productDetails?.industries}
        tags={productDetails?.tags}
      />
            
          </div>
          <div className="frame-two">
            <div className="tabs-container">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`tab-btn ${active === tab ? "active" : ""}`}
                  onClick={() => setActive(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="tab-content">
              {active === "Images" && (
                <div className="images-grid">
                  {productDetails?.media?.images && productDetails.media.images.length > 0 ? (
                    productDetails.media.images.map((image, index) => {
                      const url = typeof image === "string" ? image : image?.url;
                      if (typeof url !== "string") return null; 
                      return (
                        <img
                          key={index}
                          src={`${process.env.REACT_APP_BASE_IMAGE}/${url.replace(/\\/g, "/")}`}
                          alt={`Product view ${index + 1}`}
                          style={{
                            width: "100%",
                            height: 180,
                            objectFit: "cover",
                            borderRadius: 6,
                          }}
                        />
                      );
                    })
                  ) : (
                    <p>No images available</p>
                  )}
                </div>
              )}
              {active === "Videos" && (
                <div className="video-grid">
                  {productDetails?.media?.videos && productDetails.media.videos.length > 0 ? (
                    productDetails.media.videos
                      .filter((video) => {
                        const url = typeof video === "string" ? video : video.url;
                        return /http/.test(url); // Only include valid URLs
                      })
                      .map((video, idx) => {
                        const rawUrl = (typeof video === "string" ? video : video.url || "").trim();
                        if (!rawUrl) return null;
                        let embedUrl = rawUrl;
                        if (/youtube\.com/.test(rawUrl)) embedUrl = rawUrl.replace("watch?v=", "embed/");
                        if (/youtu\.be/.test(rawUrl)) embedUrl = rawUrl.replace("youtu.be/", "youtube.com/embed/");

                        const title = typeof video === "string"
                          ? `Video ${idx + 1}`
                          : (video.title || `Video ${idx + 1}`);
                        const description = typeof video === "string" ? "" : (video.description || "");

                        return (
                          <div className="videoCard product-video-card" key={idx}>
                            <iframe
                              src={embedUrl}
                              allowFullScreen
                              title={title}
                              className="product-video-frame"
                              style={{ width: "100%", height: 200, border: 0 }}
                            ></iframe>
                            <div className="contents video-text-responsive product-video-meta">
                              <h2 className="video-title-responsive">{title}</h2>
                              {description && <p className="video-desc-responsive">{description}</p>}
                            </div>
                          </div>
                        );
                      })
                  ) : (
                    <p>No video URLs available</p>
                  )}
                </div>
              )}
              {active === "Catalogue" && (
                <div className="catalogue-section">
                  <div className="catalogue-files-list">
                    {productDetails?.media?.catalogs && productDetails.media.catalogs.length > 0 ? (
                      productDetails.media.catalogs.map((catalog, idx) => {
                        // Support both new object format and legacy string format
                        const url = typeof catalog === "string" ? catalog : catalog?.url;
                        if (!url) return null;
                        const normalizedPath = url.replace(/\\/g, "/");
                        const fullUrl = `${process.env.REACT_APP_BASE_IMAGE}/${normalizedPath}`;
                        const name = normalizedPath.split("/").pop();
                        const title = typeof catalog === "string" ? "" : catalog?.title?.trim();
                        const description = typeof catalog === "string" ? "" : catalog?.description?.trim();
                        return (
                          <div className="catalogue-file-item" key={idx}>
                            <div className="file-info">
                              <div className="file-icon">
                                <PiFilePdf size={30} />
                              </div>
                              <div className="pdfTexts">
                                <h3 style={{ color: "#004996", fontSize: "clamp(0.6rem, 2.5vw, 1rem)" }}>
                                  {title || name}
                                </h3>
                                {description && (
                                  <p style={{ margin: "4px 0 0", fontSize: "0.875rem", color: "#4d4d4d" }}>
                                    {description}
                                  </p>
                                )}
                                <div style={{display:"flex", justifyContent:"end", marginTop:"5px"}}>
                                  <a href={fullUrl} target="_blank" rel="noreferrer" className="btn">DOWNLOAD</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p>No catalogue files available</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        </div>
    </>
  );
};

export default ProductDetailPage;